export const navStatusTypes = {
  ERROR: 'error',
  COMPLETE: 'complete',
  IN_PROGRESS: 'in-progress',
  DEFAULT: 'default',
};
